// removed by extract-text-webpack-plugin
module.exports = {"table":"TableGroupCell_table--2bKR3","isScrollable":"TableGroupCell_isScrollable--3cfNt","isProcessing":"TableGroupCell_isProcessing--2xgGP","thead":"TableGroupCell_thead--3Ky9b","tbody":"TableGroupCell_tbody--vBeek","cellGroup":"TableGroupCell_cellGroup--3FzB5","spacer":"TableGroupCell_spacer--1s5XK"};


//////////////////
// WEBPACK FOOTER
// ../node_modules/react-wot-bootstrap/lib/components/Table/TableGroupCell/TableGroupCell.css
// module id = 1830
// module chunks = 16